export default __webpack_public_path__ + "static/media/heart-blue.2d171808.svg";